<script>;
    import ActiveCall from 'screens/ActiveCall.svelte';
    import IncomingCall from 'screens/IncomingCall.svelte';
    import Modal from 'screens/Modal.svelte';
    import pubsub from 'sweet-pubsub';
    import { get } from 'svelte/store'
    import callStore from 'store/call';

    const { callSession, peer } = get(callStore);
    export let remoteAudio;

    export let mobile;
    export let incoming_call_active;
    export let answer;
    export let ring;

    

    const hangup = (event) => {
        callSession.terminate();
        pubsub.emit('hangup', { mobile: peer });
    };

    const mute = () => {
        callSession.mute();
        pubsub.emit('mute', { mobile: peer });
    };

    const unMute = () => {
        callSession.unmute();
        pubsub.emit('unMute', { mobile: peer });
    };

    const hold = () => {
        callSession.hold();
        pubsub.emit('hold', { mobile: peer });
    };

    const unHold = () => {
        callSession.unhold();
        pubsub.emit('unHold', { mobile });
    };

</script>

<div id="dialer" class="row content">
    <ActiveCall
        on:hangup={hangup}
        on:mute={mute}
        on:unMute={unMute}
        on:hold={hold}
        on:unHold={unHold}
    />
    <Modal open={incoming_call_active} out_duration="200">
        <IncomingCall
            on:hangup={hangup}
            on:answer={answer}
            {ring}
        />
    </Modal>
    <audio id="remoteAudio" bind:this={remoteAudio} />
</div>

<style lang="scss">
    #dialer {
        display: flex;
        flex-direction: column;
        flex: 1;
        padding: 0px 15px;
        height: 100%;
        .active-call-avatar {
            width: 50px;
            height: 50px;
            margin-top: 20px;
            margin-bottom: 9px;
            background: rgba(14, 153, 210, 0.10);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .call-header {
            text-align: center;
            font-size: 24px;
            font-style: normal;
            font-weight: 600;
            margin-top: 30px;
            margin-bottom: 10px;
        }
        .call-agent-info {
            text-align: center;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            opacity: 0.6;
        }
        .call-info {
            border-radius: 10px;
            background: rgba(14, 153, 210, 0.10);
            padding: 15px 20px;
            margin-bottom: 8px;
            .call-info-number {
                color: #0E99D2;
                text-align: center;
                font-size: 29px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
            }
            .call-info-copy {
                color: #000;
                text-align: center;
                font-size: 10px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
            }
        }
        .call-button {
            width: calc(100% - 30px);
            .dialer-icon {
                color: #fff;
                width: 100%;
                background-color: #0E99D2;
                padding: 10px;
                border-radius: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
        footer {
            text-align: center;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            opacity: 0.4;
            position: absolute;
            bottom: 10px;
            width: calc(100% - 30px);
        }
    }
</style>
